import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './app-checkbox.component.html',
  styleUrls: ['./app-checkbox.component.scss'],
})
export class AppCheckboxComponent implements OnInit {
  private static count = 0;
  @Input() checked = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() size = 'md';
  @Input() outline = true;
  @Input() color = 'text-primary';
  @Output() checkedChange = new EventEmitter();
  focus;
  id: string;

  constructor() { }

  ngOnInit() {
    this.id = 'app-checkbox-' + AppCheckboxComponent.count++;
  }

  toggle() {
    if (this.disabled) { return; }
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

}
